import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetTransactionServiceModel } from "@factory/model/query-model-transaction-service";
import { transactionServiceFormDefault } from "./form.default";
import { TransactionServiceFormSchema } from "./form.rule";

export const useFormDefaultTransactionService = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetTransactionServiceModel | undefined) => {
    return !cachedValue
      ? transactionServiceFormDefault
      : ({
          batch: cachedValue.batch,
          member: cachedValue.member,
          service: cachedValue.service,
          amount: cachedValue.amount,
        } as TransactionServiceFormSchema);
  };

  return {
    getDefault,
  };
};
